import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import Dropdown from '../../components/Dropdown';
import { changeFilter, changeSort } from './RequestState';
import { localize } from '../../i18n';

class RequestsTopBarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'reset',
      requestSort: 'close',
      requestFilter: 'close',
    };
  }

  render() {
    const {
      filterKey,
      sortKey,
    } = this.props;

    const filterOptions = [{
      filterKey: 'all',
      name: this.props.t('All'),
    }, {
      filterKey: 'new',
      name: this.props.t('New'),
    }, {
      filterKey: 'open',
      name: this.props.t('Open'),
    }, {
      filterKey: 'open_resolved',
      name: this.props.t('Open/Resolved'),
    }, {
      filterKey: 'resolved',
      name: this.props.t('Resolved'),
    }, {
      filterKey: 'closed',
      name: this.props.t('Closed'),
    }, {
      filterKey: 'urgent',
      name: this.props.t('Urgent'),
    }, {
      filterKey: 'assigned',
      name: this.props.t('Assigned to Me'),
    }];


    const sortOptions = [{
      sortKey: '-status',
      name: this.props.t('Status Desc.'),
    }, {
      sortKey: 'status',
      name: this.props.t('Status Asc.'),
    }, {
      sortKey: '-delivery',
      name: this.props.t('Delivery Time Desc.'),
    }, {
      sortKey: 'delivery',
      name: this.props.t('Delivery Time Asc.'),
    }, {
      sortKey: '-_created',
      name: this.props.t('Submitted Desc.'),
    }, {
      sortKey: '_created',
      name: this.props.t('Submitted Asc.'),
    }, {
      sortKey: 'room',
      name: this.props.t('Room Asc.'),
    }, {
      sortKey: '-room',
      name: this.props.t('Room Desc.'),
    }, {
      sortKey: 'severity',
      name: this.props.t('By Severity'),
    }];


    const filterItems = filterOptions.map(item => (
      <li key={item.filterKey} className={`${(item.filterKey === filterKey) ? 'uk-active' : ''}`}>
        <span
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              status: 'filtering',
              requestFilter: 'close',
            });
            this.props.dispatch(changeFilter(item.filterKey));
          }}
        >
          {item.name}
        </span>
      </li>
    ));


    const sortItems = sortOptions.map(item => (
      <li key={item.sortKey} className={`${(item.sortKey === sortKey) ? 'uk-active' : ''}`}>
        <span
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              status: 'sorting',
              requestSort: 'close',
            });
            this.props.dispatch(changeSort(item.sortKey));
          }}
        >
          {item.name}
        </span>
      </li>
    ));

    const currentFilter = _.find(filterOptions, { filterKey }).name;
    const currentSort = _.find(sortOptions, { sortKey }).name;

    return (
      <div>
        <Dropdown
          href="#filter-dropdown"
          label={[
            <i className="material-icons" key="1">&#xE152;</i>,
            <span className="dropdown-label short" key="2">{currentFilter}</span>,
            <i className="material-icons" key="3">&#xE313;</i>,
          ]}
          request={this.state.requestFilter}
          onChange={(changeRequest) => {
            this.setState({
              requestFilter: changeRequest === true ? 'open' : 'close',
            });
          }}
          wrapperClassName="uk-button-dropdown"
          className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button"
        >
          <ul className="uk-nav uk-nav-dropdown">
            {filterItems}
          </ul>
        </Dropdown>

        <Dropdown
          href="#sort-dropdown"
          label={[
            <i className="material-icons" key="1">&#xE164; </i>,
            <span key="2" className="dropdown-label short">{currentSort}</span>,
            <i className="material-icons" key="3">&#xE313;</i>,
          ]}
          request={this.state.requestSort}
          onChange={(changeRequest) => {
            this.setState({
              requestSort: changeRequest === true ? 'open' : 'close',
            });
          }}
          wrapperClassName="uk-button-dropdown"
          className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button"
        >
          <ul className="uk-nav uk-nav-dropdown">
            {sortItems}
          </ul>
        </Dropdown>
      </div>
    );
  }
}

RequestsTopBarFilter.propTypes = {
  filterKey: PropTypes.string,
  sortKey: PropTypes.string,
  dispatch: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    views: {
      requests: {
        filter: filterKey,
        sort: sortKey,
      },
    },
  } = state;

  return {
    filterKey,
    sortKey,
  };
};

export default localize(connect(mapStateToProps)(RequestsTopBarFilter));



// WEBPACK FOOTER //
// ./src/views/requests/RequestsTopBarFilter.js